import type { DocumentOcrPage } from 'features/knowledgeDocumentViewer/types/ocrViewer'

export function ocrAtDocumentPoint(
  page: DocumentOcrPage | undefined,
  x: number,
  y: number
) {
  if (!page) return undefined
  return [...page.confirmed, ...page.unconfirmed]
    .filter((box) => {
      const b = box.bounding_box
      return (
        box.text?.trim() &&
        x >= b.left &&
        x <= b.left + b.width &&
        y >= b.top &&
        y <= b.top + b.height
      )
    })
    .sort(
      (a, b) =>
        a.bounding_box.width * a.bounding_box.height -
        b.bounding_box.width * b.bounding_box.height
    )[0]
}

export function textAtDocumentPoint(
  page: DocumentOcrPage | undefined,
  x: number,
  y: number
): string {
  return ocrAtDocumentPoint(page, x, y)?.text?.trim() ?? ''
}

export function crossReferenceRegion(
  x: number,
  y: number
): [number, number, number, number] {
  return [
    Math.max(0, x - 0.035),
    Math.max(0, y - 0.015),
    Math.min(1, x + 0.035),
    Math.min(1, y + 0.015),
  ]
}
